import React from 'react';
import { Grid, Card, Text, useMantineTheme, Group, SimpleGrid, Divider, Avatar, Box } from '@mantine/core';

import { utils } from "../../utils/globalVariables";
import { sqlDateToHumanDate, getObjectParam2, CustomerCategoryIcon, stringDivider, safeValue } from "../../utils/globalFunctions";

import LabelContentInline from "../../components/general/LabelContentInline";
import SortSegmentedControl from "../../components/general/SortSegmentedControl";

import DeadlinePengecekan from "../../components/utilities/DeadlinePengecekan";
import DeadlineSelesai from "../../components/utilities/DeadlineSelesai";

import LastComment from "../../components/general/LastComment";

const ProjectNotaCard = ({ stateData, stateSortList, stateSortSelected, fnSort, fnSelectedData, fnFeedback }) => {

  const theme = useMantineTheme();

  return (
    <React.Fragment>

      <SortSegmentedControl
        stateSortList={stateSortList}
        stateSortSelected={stateSortSelected}
        fnSort={fnSort}
        stateStyle={{ marginBottom: theme.spacing.md }}
      />

      <SimpleGrid
        cols={1}
        spacing='md'
        breakpoints={[
          { minWidth: 'xl', cols: 4, spacing: 'md' },
          { minWidth: 'lg', cols: 3, spacing: 'md' },
          { minWidth: 'md', cols: 2, spacing: 'md' },
          { minWidth: 'sm', cols: 2, spacing: 'md' },
          { minWidth: 'xs', cols: 2, spacing: 'md' },
        ]}
      >
        {Object.keys(stateData).map((key, index) => {
          return (
            <Card
              key={key}
              shadow=''
              radius="md"
              withBorder={true}

              style={{
                borderColor: theme.colorScheme === 'light' ? theme.colors.gray[2] : theme.colors.dark[7],
                backgroundColor: theme.colorScheme === 'light' ? '#fff' : theme.colors.dark[7],
                overflow: 'unset',
                cursor: 'pointer',
              }}

              onClick={() => {
                fnSelectedData(stateData[key]);
              }}
            >
              <Card.Section p='sm'>
                <Text size="sm">
                  <Grid>
                    <Grid.Col
                      span={12}
                      sx={{
                        // color: theme.colorScheme === 'light' ? theme.colors.gray[6] : theme.colors.gray[6]
                      }}
                    >
                      <Group align='flex-start' noWrap>
                        <Avatar
                          radius="xl"
                          size='2rem'
                          styles={(tema) => ({
                            placeholder: {
                              backgroundColor: tema.fn.rgba((theme.colorScheme === 'light' ? getObjectParam2(utils.priority, String(stateData[key].project_priority), 'colorBgLight', tema.colors.gray[1]) : getObjectParam2(utils.priority, String(stateData[key].project_priority), 'colorBgDark', tema.colors.dark[5])), 0.75)
                            }
                          })}
                        >
                          <CustomerCategoryIcon
                            stateCustomerCategory={stateData[key].customer_category_slug}
                            stateSize='1.25rem'
                            stateStroke={1.75}
                            stateColor={theme.colorScheme === 'light' ? (stateData[key].project_priority ? '#fff' : '#000') : '#fff'}
                          />
                        </Avatar>

                        <Box>
                          <Text size="sm" fw={500} lineClamp={1}>
                            {stateData[key].customer_name}
                          </Text>

                          <Text size="xs" lineClamp={1} color='dimmed'>
                            {stateData[key].customer_category_name}
                          </Text>

                          <Text size="xs" lineClamp={1} color='dimmed'>
                            {stateData[key].customer_group_name ? stateData[key].customer_group_name : '[Group]'}
                          </Text>

                          <Text size="xs" lineClamp={1} color='dimmed'>
                            Id Card {stateData[key].customer_id_card_number ? stateData[key].customer_id_card_number : ' - '}
                          </Text>
                        </Box>
                      </Group>
                    </Grid.Col>
                  </Grid>

                  <Divider
                    mt='.5rem'
                    mb='.5rem'
                    sx={{
                      borderTopWidth: '1px',
                      borderStyle: 'dashed',
                      borderTopColor: theme.colorScheme === 'light' ? theme.colors.gray[2] : theme.colors.dark[5]
                    }}
                  />

                  <LabelContentInline
                    stateColLabel={4}
                    stateLabel={stateSortList.projectId.caption}
                    stateContent={stringDivider(stateData[key].project_id, [4, 6, 8], '.', '[Nomor Nota]')}
                    stateDivider={true}
                  />

                  <LabelContentInline
                    stateColLabel={4}
                    stateLabel='Barang'
                    stateContent={
                      <Box>
                        {stateData[key].barang_category_name ?
                          <Text lineClamp={1}>
                            {safeValue(stateData[key].barang_category_name, '[Kategori Barang]')}
                          </Text>
                          :
                          <Text lineClamp={1} color='dimmed'>
                            [Kategori Barang]
                          </Text>
                        }

                        {stateData[key].barang_nama ?
                          <Text lineClamp={1}>
                            {safeValue(stateData[key].barang_nama, '[Nama Barang]')}
                          </Text>
                          :
                          <Text lineClamp={1} color='dimmed'>
                            [Nama Barang]
                          </Text>
                        }

                        {stateData[key].barang_keluhan ?
                          <Text lineClamp={1}>
                            {safeValue(stateData[key].barang_keluhan, '[Keluhan]')}
                          </Text>
                          :
                          <Text lineClamp={1} color='dimmed'>
                            [Keluhan]
                          </Text>
                        }
                      </Box>
                    }
                    stateDivider={true}
                  />

                  <LabelContentInline
                    stateColLabel={4}
                    stateLabel={stateSortList.tanggalNota.caption}
                    stateContent={sqlDateToHumanDate({
                      stateDate: stateData[key].tanggal_nota,
                      stateWithTime: false,
                      stateLang: 'id',
                      stateIsShort: false,
                      stateDay: false,
                      stateDefaultValue: ' - ',
                      stateDateType: 'day'
                    })}
                    stateDivider={true}
                  />

                  <LabelContentInline
                    stateColLabel={4}
                    stateLabel={stateSortList.tanggalDateLinePengecekan.caption}
                    stateContent={
                      <Box>
                        <Text>
                          {sqlDateToHumanDate({
                            stateDate: stateData[key].date_line_pengecekan,
                            stateWithTime: false,
                            stateLang: 'id',
                            stateIsShort: false,
                            stateDay: false,
                            stateDefaultValue: ' - ',
                            stateDateType: 'day'
                          })}
                        </Text>

                        <DeadlinePengecekan
                          stateToday={stateData[key].today}
                          stateDeadlinePengecekan={stateData[key].date_line_pengecekan}
                          stateHasPengecekan={stateData[key].has_pengecekan}
                        />
                      </Box>
                    }
                    stateDivider={true}
                  />

                  <LabelContentInline
                    stateColLabel={4}
                    stateLabel={stateSortList.tanggalDateLineSelesai.caption}
                    stateContent={
                      <Box>
                        <Text>
                          {sqlDateToHumanDate({
                            stateDate: stateData[key].date_line_selesai,
                            stateWithTime: false,
                            stateLang: 'id',
                            stateIsShort: false,
                            stateDay: false,
                            stateDefaultValue: ' - ',
                            stateDateType: 'day'
                          })}
                        </Text>

                        <DeadlineSelesai
                          stateToday={stateData[key].today}
                          stateDeadlineSelesai={stateData[key].date_line_selesai}
                          stateTanggalSelesai={stateData[key].tanggal_selesai}
                        />
                      </Box>
                    }
                    stateDivider={true}
                  />

                  <LabelContentInline
                    stateColLabel={4}
                    stateLabel={stateSortList.teknisi.caption}
                    stateContent={
                      <Box>
                        <Text lineClamp={1}>{safeValue(stateData[key].penerima_rekomendasi_nama, '-')}</Text>
                        {/* {stateData[key].recommendation_info && */}
                        <Text lineClamp={1}>{safeValue(stateData[key].recommendation_info, '-')}</Text>
                        {/* } */}
                      </Box>
                    }
                    stateDivider={true}
                  />

                  <LastComment
                    stateData={stateData[key].feedback}
                    fnFeedback={(e) => {
                      e.stopPropagation();
                      fnFeedback(stateData[key]);
                    }}
                  />
                </Text>
              </Card.Section>
            </Card>
          )
        })}
      </SimpleGrid>
    </React.Fragment>
  )
}

export default React.memo(ProjectNotaCard);